import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InventoryIdenty, ShoppingCart, TypeShoppingCart } from '../model/inventories';

@Injectable()
export class ShoppingElementsService {

  private allElements: any[] = [];

  private insertionElements: InventoryIdenty[] = [];
  private loanElements: any[] = [];
  private partialLoanElements: any[] = [];
  private totalElements = 0;

  allElements$ = new BehaviorSubject<InventoryIdenty[]>(null);
  insertionElements$ = new BehaviorSubject<InventoryIdenty[]>(null);
  loanElements$ = new BehaviorSubject<InventoryIdenty[]>(null);
  partialLoanElements$ = new BehaviorSubject<InventoryIdenty[]>(null);
  totalElements$ = new BehaviorSubject<number>(this.totalElements);
  constructor() { }

  private unidadesDocumentalesParaPrestar: { clientId: number, identidades: InventoryIdenty[] };

  addOrReplaceInsertionElement(identy: InventoryIdenty): InventoryIdenty {
    let record = this.insertionElements.find(rec => rec.id == identy.id);
    if (record) {
      record = identy;
      return record;
    }
    identy.shoppingCart = this.getShoppingCart(TypeShoppingCart.INSERTION);
    this.insertionElements.push(identy);
    this.allElements.push(identy);
    this.totalElements++;
    this.flushElements(this.insertionElements, this.insertionElements$);
    return identy;
  }

  addOrReplaceLoanElement(identy: InventoryIdenty): InventoryIdenty {
    let record = this.loanElements.find(rec => rec.id == identy.id);
    if (record) {
      record = identy;
      return record;
    }
    identy.shoppingCart = this.getShoppingCart(TypeShoppingCart.LOAN);
    this.loanElements.push(identy);
    this.allElements.push(identy);
    this.totalElements++;
    this.flushElements(this.loanElements, this.loanElements$);
    return identy;
  }

  addOrReplacePartialLoanElement(identy: InventoryIdenty, obsPartial: string): InventoryIdenty {
    let record = this.partialLoanElements.find(rec => rec.id == identy.id);
    if (record) {
      identy.shoppingCart.obsPartial = obsPartial;
      record = identy;
      return record;
    }
    identy.shoppingCart = this.getShoppingCart(TypeShoppingCart.PARTIAL_LOAN, obsPartial);
    this.partialLoanElements.push(identy);
    this.allElements.push(identy);
    this.totalElements++;
    this.flushElements(this.partialLoanElements, this.partialLoanElements$);
    return identy;
  }

  removeElement(element: InventoryIdenty): boolean {
    const elemento = this.allElements.find(el => el.id == element.id);
    if (!elemento) {
      return false;
    }
    switch (elemento.shoppingCart.type) {
      case TypeShoppingCart.LOAN: {
        this.loanElements = this.removeElementInArray(elemento.id, this.loanElements);
        this.flushElements(this.loanElements, this.loanElements$);
        break;
      }
      case TypeShoppingCart.INSERTION: {
        this.insertionElements = this.removeElementInArray(elemento.id, this.insertionElements);
        this.flushElements(this.insertionElements, this.insertionElements$);
        break;
      }
      case TypeShoppingCart.PARTIAL_LOAN: {
        this.partialLoanElements = this.removeElementInArray(elemento.id, this.partialLoanElements);
        this.flushElements(this.partialLoanElements, this.partialLoanElements$);
        break;
      }
      default: {
        console.log('Error en el tipo del carrito');
        break;
      }
    }
    return true;
  }

  private removeElementInArray(identityId, arrayElements: InventoryIdenty[]): InventoryIdenty[] {
    const element = arrayElements.find(expediente => expediente.id == identityId);
    if (element) {
      arrayElements = arrayElements.filter(obj => obj !== element);
      this.allElements = this.allElements.filter(obj => obj !== element);
      this.totalElements--;
      return arrayElements;
    }
    return null;
  }

  private flushElements(identy: InventoryIdenty[],
    tipoExpedientes: BehaviorSubject<InventoryIdenty[]>) {// todo revisar esto
    tipoExpedientes.next(identy);
    this.totalElements$.next(this.totalElements);
    this.allElements$.next(this.allElements);
  }

  private getShoppingCart(typeShoppingCart: TypeShoppingCart, obsPartial?: string): ShoppingCart {
    const shoppingCart = new ShoppingCart();
    shoppingCart.type = typeShoppingCart;
    shoppingCart.obsPartial = obsPartial;
    return shoppingCart;
  }


  getRecordsWithCartInformation(elements: InventoryIdenty[]): any[] {
    const elementosCarrito = [...this.insertionElements, ...this.loanElements, ...this.partialLoanElements];
    elements.forEach((element: InventoryIdenty) => {
      element = this.getRecordWithCartInformation(element, elementosCarrito);
    });

    return elements;
  }

  getRecordWithCartInformation(element: InventoryIdenty, elementosCarrito?: InventoryIdenty[]): InventoryIdenty {
    const elementsShoppingCart = !elementosCarrito ? [...this.insertionElements, ...this.loanElements, ...this.partialLoanElements]
                                                    : elementosCarrito;
    const register = elementsShoppingCart.find((rec: InventoryIdenty) => rec.id == element.id && element.tipoDocumental == rec.tipoDocumental);

    if (register) {
      element.shoppingCart = register.shoppingCart;
    }
    return element;
   }

  emptyCart() {
    this.insertionElements = [];
    this.loanElements = [];
    this.partialLoanElements = [];
    this.allElements = [];
    this.totalElements = 0;
    this.flushAll();
  }

  private flushAll() {
    this.allElements$.next(this.allElements);
    this.insertionElements$.next(this.insertionElements);
    this.loanElements$.next(this.loanElements);
    this.partialLoanElements$.next(this.partialLoanElements);
    this.totalElements$.next(this.totalElements);
  }

  putElementsToLoan(expedientes: { clientId: number, identidades: InventoryIdenty[] }): void {
    this.unidadesDocumentalesParaPrestar = expedientes;
  }

  getElementsToLoan(): { clientId: number, identidades: InventoryIdenty[] } {
    return this.unidadesDocumentalesParaPrestar;
  }
}
